import { supabase } from './supabase';

const FONNTE_TOKEN = process.env.REACT_APP_FONNTE_TOKEN;

async function sendWA(to, message) {
  if (!FONNTE_TOKEN) { console.warn('Fonnte token not set'); return; }
  const wa = to.replace(/^0/, '62').replace(/[^0-9]/g, '');
  try {
    await fetch('https://api.fonnte.com/send', {
      method: 'POST',
      headers: { 'Authorization': FONNTE_TOKEN },
      body: new URLSearchParams({ target: wa, message }),
    });
  } catch (e) {
    console.error('Fonnte error:', e);
  }
}

function fmtDate(d) {
  return new Date(d).toLocaleDateString('id-ID', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}

// Baris rincian pesanan
function buildOrderLines(productName, totalQty, total, payMethod, items) {
  const payLabel = payMethod === 'cod' ? 'COD' : 'Non-Tunai';
  if (items && items.length > 0) {
    const lines = items
      .map(i => `  • ${i.qty} pack ${i.variant.name} — Rp ${i.subtotal.toLocaleString('id-ID')}`)
      .join('\n');
    return `*${productName}*\n${lines}\nTotal: *Rp ${Number(total).toLocaleString('id-ID')}* (${payLabel})`;
  }
  return `*${totalQty} pack ${productName}*\nTotal: *Rp ${Number(total).toLocaleString('id-ID')}* (${payLabel})`;
}

export const WA_MESSAGES = {
  // COD: pesanan diterima langsung
  orderConfirmCOD: (orderId, customerName, totalQty, productName, total, area, date, timeStart, items) =>
    `Halo *${customerName}* 👋\n\nPesanan kamu sudah kami terima! ✅\n\n` +
    `🆔 *Order ID:* ${orderId}\n💳 *Metode:* COD (Bayar saat terima)\n\n` +
    `${buildOrderLines(productName, totalQty, total, 'cod', items)}\n\n` +
    `📍 Area: ${area}\n📅 Pengiriman: ${fmtDate(date)} pukul ${timeStart}\n\n` +
    `Kami akan konfirmasi lagi via WhatsApp saat pesanan diproses. Terima kasih sudah order di *HAPin* 🍟`,

  // Non-tunai: pesanan diterima, menunggu pembayaran
  orderConfirmNonTunai: (orderId, customerName, totalQty, productName, total, area, date, timeStart, items) =>
    `Halo *${customerName}* 👋\n\nPesanan kamu sudah kami terima dan sedang menunggu pembayaran ⏳\n\n` +
    `🆔 *Order ID:* ${orderId}\n💳 *Metode:* Non-Tunai (Transfer/QRIS/E-wallet)\n\n` +
    `${buildOrderLines(productName, totalQty, total, 'non-tunai', items)}\n\n` +
    `📍 Area: ${area}\n📅 Pengiriman: ${fmtDate(date)} pukul ${timeStart}\n\n` +
    `Segera selesaikan pembayaran ya. Pesanan baru diproses setelah pembayaran dikonfirmasi 🙏\n\n_HAPin_`,

  // Non-tunai: pembayaran berhasil dikonfirmasi
  paymentSuccess: (orderId, customerName, productName, total) =>
    `Halo *${customerName}* 🎉\n\nPembayaran kamu sudah kami terima!\n\n` +
    `🆔 *Order ID:* ${orderId}\n✅ *Status:* Pembayaran Berhasil\n💰 *Jumlah:* Rp ${Number(total).toLocaleString('id-ID')}\n📦 *Produk:* ${productName}\n\n` +
    `Pesanan kamu sekarang sedang diproses. Kami akan info lagi saat pesanan dikirim. Terima kasih sudah order di *HAPin* 🍟`,

  diproses: (customerName, productName, area, date, timeStart) =>
    `Halo *${customerName}* 👋\n\nKabar gembira, kuota PO *${productName}* Area ${area} dengan tanggal pengiriman ${fmtDate(date)} pukul ${timeStart} sudah terpenuhi! \n\nPesananmu sekarang sedang diproses. Kurir kami akan menghubungi kamu sebelum tiba. Terima kasih sudah order di *HAPin* 🍟`,

  dikirim: (customerName, area) =>
    `Halo *${customerName}* 🛵\n\nPesanan kamu di area *${area}* sedang dalam perjalanan!\n\nKurir kami sudah berangkat. Harap siap di lokasi COD ya. Kalau ada pertanyaan, balas pesan ini.`,

  ditempat: (customerName, timeEnd) =>
    `Halo *${customerName}* 📍\n\nKurir HAPin sudah tiba di lokasi COD kamu!\n\nKurir menunggu sampai pukul *${timeEnd}*. Segera menuju lokasi ya 🙏`,

  selesai: (customerName, productName) =>
    `Halo *${customerName}* 🎉\n\nTerima kasih sudah order *${productName}* dari HAPin!\n\nBagaimana rasanya? Kami sangat menghargai feedback kamu 😊\n\nCeritakan pengalamanmu di sini atau kirim foto ya — siapa tahu kita share di TikTok! 📱\n\n_Reply pesan ini untuk feedback_`,

  batal: (customerName, productName, area, paymentMethod = 'cod', paymentStatus = 'unpaid') => {
    const sudahBayar = paymentMethod === 'non-tunai' && paymentStatus === 'paid';
    const baseMsg =
      `Halo *${customerName}* 😔\n\n` +
      `Mohon maaf, PO *${productName}* untuk area *${area}* dibatalkan karena belum mencapai kuota minimum.\n\n`;
    const refundMsg = sudahBayar
      ? `Karena kamu sudah melakukan pembayaran, kami akan memproses refund ke rekeningmu.\n\n` +
        `Mohon *balas pesan ini* dengan mengirimkan:\n` +
        `  • Nama Bank\n` +
        `  • Nomor Rekening\n` +
        `  • Nama Pemilik Rekening\n\n` +
        `Refund akan diproses dalam 1–3 hari kerja setelah data rekening diterima 🙏`
      : `Uang tidak dipotong karena sistem COD.`;
    return baseMsg + refundMsg + `\n\nPantau terus TikTok & WA kami untuk jadwal PO berikutnya ya!\n\n_Tim HAPin_`;
  },

  followUp: (customerName, productName) =>
    `Halo *${customerName}* 😊\n\nKami kangen kamu nih! Sudah lama tidak pesan *${productName}* dari HAPin.\n\nAda yang bisa kami bantu atau ada masukan untuk kami? Balas pesan ini ya, kami selalu senang mendengar dari pelanggan setia kami 🍟`,
};

export async function sendStatusWA(orders, po, product, area) {
  for (const order of orders) {
    if (!order.customer_wa) continue;
    let msg = '';
    switch (po.status) {
      case 'diproses':
        msg = WA_MESSAGES.diproses(order.customer_name, product.name, area.name, po.date, po.time_start); break;
      case 'dikirim':
        msg = WA_MESSAGES.dikirim(order.customer_name, area.name); break;
      case 'ditempat':
        msg = WA_MESSAGES.ditempat(order.customer_name, po.time_end); break;
      case 'selesai':
        msg = WA_MESSAGES.selesai(order.customer_name, product.name); break;
      case 'batal':
        msg = WA_MESSAGES.batal(order.customer_name, product.name, area.name, order.payment_method, order.payment_status); break;
      default: continue;
    }
    await sendWA(order.customer_wa, msg);
    await new Promise(r => setTimeout(r, 500));
  }
}

export async function sendFollowUpWA(customerWa, customerName, productName) {
  const msg = WA_MESSAGES.followUp(customerName, productName);
  await sendWA(customerWa, msg);
}

// items: array selectedItems ({ variant: { name }, qty, subtotal }) — opsional, null jika tanpa varian
// payMethod: 'cod' | 'non-tunai'
export async function sendOrderConfirmWA(customerWa, orderId, customerName, totalQty, productName, total, area, date, timeStart, payMethod = 'cod', items = null) {
  const msg = payMethod === 'cod'
    ? WA_MESSAGES.orderConfirmCOD(orderId, customerName, totalQty, productName, total, area, date, timeStart, items)
    : WA_MESSAGES.orderConfirmNonTunai(orderId, customerName, totalQty, productName, total, area, date, timeStart, items);
  await sendWA(customerWa, msg);
}

export async function sendPaymentSuccessWA(customerWa, orderId, customerName, productName, total) {
  const msg = WA_MESSAGES.paymentSuccess(orderId, customerName, productName, total);
  await sendWA(customerWa, msg);
}

// ═══════════════════════════════════════════════════════════════════
// Order Now — pesanan langsung (bukan batch PO), COD only
// items: array cart [{ product_name, variant_name, qty, price }]
// fulfillType: 'pickup' | 'delivery'
// ═══════════════════════════════════════════════════════════════════
function buildDirectOrderLines(items) {
  return items
    .map(i => `  • ${i.variant_name || i.product_name} × ${i.qty} — Rp ${(i.price * i.qty).toLocaleString('id-ID')}`)
    .join('\n');
}

export async function sendDirectOrderConfirmWA(customerWa, orderId, customerName, items, total, fulfillType, fulfillDate, address) {
  const caraTerima = address ? `Ambil sendiri di ${address}` : 'Ambil sendiri di lokasi kami (info menyusul)';
  const msg =
    `Halo *${customerName}* 👋\n\nPesanan kamu sudah kami terima! ✅\n\n` +
    `💳 *Metode:* COD (Bayar saat terima)\n\n` +
    `${buildDirectOrderLines(items)}\n\nTotal: *Rp ${Number(total).toLocaleString('id-ID')}*\n\n` +
    `📅 Tanggal: ${fmtDate(fulfillDate)}\n📍 ${caraTerima}\n\n` +
    `Kami akan konfirmasi lagi via WhatsApp. Terima kasih sudah order! 🙏`;
  await sendWA(customerWa, msg);
}

// ═══════════════════════════════════════════════════════════════════
// Order menu POS via web — pesanan langsung diproses dapur (bukan PO/batch)
// items: array cart [{ product_name, variant_name, note, qty, price }]
// ═══════════════════════════════════════════════════════════════════
function buildPOSOrderLines(items) {
  return items
    .map(i => {
      const label = i.variant_name ? `${i.product_name} – ${i.variant_name}` : i.product_name;
      const note = i.note ? ` (${i.note})` : '';
      return `  • ${i.qty}x ${label}${note} — Rp ${(i.price * i.qty).toLocaleString('id-ID')}`;
    })
    .join('\n');
}

// Ambil daftar nomor WA staf dapur dari app_settings (key: kitchen_wa_numbers, dipisah koma)
async function getKitchenWaNumbers() {
  const { data } = await supabase.from('app_settings').select('value').eq('key', 'kitchen_wa_numbers').maybeSingle();
  return (data?.value || '').split(',').map(s => s.trim()).filter(Boolean);
}

// Konfirmasi ke customer setelah order menu POS lewat web
export async function sendPOSOrderConfirmWA(customerWa, orderId, customerName, items, total, fulfillType, address, fulfillTime) {
  const caraTerima = fulfillType === 'delivery' ? `Diantar ke: ${address}` : 'Ambil sendiri di lokasi kami';
  const jamInfo = fulfillTime ? `\n🕐 Jam ${fulfillType === 'delivery' ? 'diantar' : 'diambil'}: ${fulfillTime}` : '';
  const msg =
    `Halo *${customerName}* 👋\n\nPesanan kamu sudah kami terima dan sedang disiapkan dapur kami! 👨‍🍳\n\n` +
    `🆔 *Order ID:* ${orderId}\n💳 *Metode:* COD (Bayar saat terima)\n\n` +
    `${buildPOSOrderLines(items)}\n\nTotal: *Rp ${Number(total).toLocaleString('id-ID')}*\n\n` +
    `📍 ${caraTerima}${jamInfo}\n\n` +
    `Kami akan kabari lagi saat pesanan siap. Terima kasih sudah order! 🙏`;
  await sendWA(customerWa, msg);
}

// Notifikasi ke staf dapur setiap ada order baru dari web (menu POS)
export async function notifyKitchenNewOrder(orderId, customerName, items, total, fulfillType, address, fulfillTime) {
  const numbers = await getKitchenWaNumbers();
  if (numbers.length === 0) { console.warn('Nomor WA staf dapur belum diatur di Settings'); return; }

  const caraTerima = fulfillType === 'delivery' ? `Delivery — ${address}` : 'Take Away';
  const jamInfo = fulfillTime ? `\n🕐 Jam: ${fulfillTime}` : '';
  const msg =
    `🔔 *Order Online Baru!*\n\n` +
    `🆔 ${orderId}\n👤 ${customerName}\n📦 ${caraTerima}${jamInfo}\n\n` +
    `${buildPOSOrderLines(items)}\n\nTotal: *Rp ${Number(total).toLocaleString('id-ID')}*\n\n` +
    `Cek & proses di Order POS ya 🙏`;

  for (const num of numbers) {
    await sendWA(num, msg);
    await new Promise(r => setTimeout(r, 400));
  }
}
